export const fontWeights = {
  thin: {fontWeigth: 100},
  extra_light: {fontWeigth: 200},
  light: {fontWeigth: 300},
  normal: {fontWeigth: 400},
  medium: {fontWeigth: 500},
  semi_bold: {fontWeigth: 600},
  bold: {fontWeigth: 700},
  extra_bold: {fontWeigth: 800},
  black: {fontWeigth: 900},
};

export const fonts = {
  inter: {fontFamily: 'inter'},
  source_sans_3: {fontFamily: 'sourcesans3'},
};
